// import "server-only";

export const token =
  'sktaJMpvu2kcFg6FbyZT8tqMYGhMyNiT8G30IhxSgnklbb8krqJH8eUmpT1PTGjL4r0BC1JT8JlrZGQ0ReKD3amlELnNUIpL0NsAyirE3m0ZuHc4EQXX7atBRqo9wReskUCAGVkMFJQ1IQ8luW0Bcjt7DG0a52iGvlyRl8Nq8SszB8Ssxyen';

if (!token) {
  throw new Error('Missing SANITY_API_READ_TOKEN');
}
